import React, { useState } from 'react';

export default function GalleryImage({ url, insertImageF, chooseMagazine, galleryForLink, magazine, insertImageMode, handleInsert, handleSelectShopImage, chosingCover, choseCoverF, AdmGal }) {
  const [selectedFromGallery, setSelectedFromGallery] = useState(false);

  const handle = () => {
    if (chosingCover) {
      choseCoverF(url);
    } else if (insertImageMode) {
      insertImageF(url);
    } else if(galleryForLink) {
      handleInsert(url)
    } else if (magazine) {
      chooseMagazine(url)
    } 
    else {
      handleSelectShopImage(url);
    } 
  };

  const selectedFrom = () => {
    if(AdmGal) {
      
    } else{
      setSelectedFromGallery(true);
    }

  };

  return (
    <div className='imgUploadContGallery___imageCont'>
      {selectedFromGallery ? (
        <button onClick={handle} className='buttongreenGallery'>
          {chosingCover ? "ELEGIR" : "AGREGAR"}
        </button>
      ) : (
        <></>
      )}
      <img
        onClick={selectedFrom}
        className={selectedFromGallery ? 'imgUploadContGallery___image byn' : 'imgUploadContGallery___image'}
        src={url}
        alt=""
      />
    </div>
  );
}

